class TabComponent extends HTMLElement {
  constructor() {
    super()
      this.addEventListener("click",this.main.bind(this));
     }
     main(){
      if(this.hasAttribute('disabled')){return}
      this.closeTab();
      this.openTab();
     }
     connectedCallback() {
      if (this.dataset.sectionId) {
        this.sectionReference = document.getElementById(this.dataset.sectionId);
      }
     }
     openTab(){
      this.classList.add("active");
      if (this.sectionReference && this.dataset.openTab) {
        this.sectionReference.querySelectorAll(`#${this.dataset.openTab}`).forEach(tab => {
            tab.classList.add("active");
        });
        this.sectionReference.querySelectorAll(`[data-open-tab=${this.dataset.openTab}]`).forEach(tab => {
            tab.classList.add("active");
            if (tab instanceof HTMLElement && tab.dataset.step) {
                // Get the value of data-step attribute from the clicked element
                var stepValue = this.dataset.step;
                if (stepValue) {
                  // Set ?step=value in the URL
                  var urlParams = new URLSearchParams(window.location.search);
                  urlParams.set('step', stepValue);
                  window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());
                }
            }
        });
      }
     }
     closeTab(){
      if (this.sectionReference) {
        this.sectionReference.querySelectorAll("tab-component.active").forEach(tab => {
            tab.classList.remove("active");
        });
        this.sectionReference.querySelectorAll(".tab__content.active").forEach(tab => {
            tab.classList.remove("active");
        });
      }
     }
 
}
customElements.define("tab-component", TabComponent)